
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import errorService from "../../services/errorService";
import {TOTP_REGEX} from "@/constant/regex";
import ErrorCard from "@/components/partials/ErrorCard.vue";
import XCardBasedForm from "@/components/XCardBasedForm.vue";
import WaitBase from "./partials/WaitBase.vue";

export default Vue.extend({
  components: {XCardBasedForm, ErrorCard, WaitBase},
  data() {
    return {
      errorService,
      resetOtp: false,
      preparing: false,
      prepareError: "",
      prepareResponse: null,
      isSystemError: false,
      fetching: false,
      fetchError: "",
      fetchResponse: null,
      fetchOtp: "",
      showDetailError: false,
      error: "",
      binding: {}
    };
  },
  async created() {
    await msDataProvider.bindDataMany(
        ["enrollmentEnrollmentStatus", "authenAuthenInfo"],
        this.binding,
        this,
        (key, data) => {
          if (key === "enrollmentEnrollmentStatus" && data.fetched) {
            if (data.approved) {
              this.$router.push("/main");
              return;
            } else if(data.error === "request_decline") {
              this.$router.push({name: "enrollment-result"});
            }
          }
        },
        this
    );
    await this.prepare();
  },
  computed: {
    isErrorSmsOtp() {
      return this.prepareResponse && this.prepareResponse.error_info && this.prepareResponse.error_info.error_code === 405
    }
  },
  methods: {
    async prepare(resend = false) {
      try {
        this.resetError();
        this.preparing = true;
        this.prepareResponse = await msDataProvider.executeCommand(
            "enrollmentPrepareFetchingEnrollmentRequest",
            {
              mfa_resend: resend,
            }
        );
        this.isSystemError = false;
      } catch (e) {
        this.prepareError = e;
        this.isSystemError = true;
      } finally {
        this.preparing = false;
      }
    },
    async fetch() {
      try {
        this.fetching = true;
        this.fetchResponse = await msDataProvider.executeCommand(
            "enrollmentFetchEnrollmentRequest",
            {
              mfa_session_id: this.prepareResponse.mfa_session_id,
              mfa_request_id: this.prepareResponse.mfa_request_id,
              mfa_otp: this.fetchOtp,
            }
        );
        if (this.fetchResponse && this.fetchResponse.mfa_error_info && this.fetchResponse.mfa_error_info.error_code) {
          this.fetchOtp = "";
          return;
        }
        this.isSystemError = false;
        this.$router.push('/main')
      } catch (e) {
        this.fetchOtp = "";
        const {err, showNotiSystem} = this.errorService.normalize(e)
        if (showNotiSystem) {
          this.fetchError = e;
          this.isSystemError = true;
        } else {
          this.fetchError = err;
          this.isSystemError = false;
        }
      } finally {
        this.fetching = false;
      }
    },
    focus(event) {
      event.target.select();
    },
    async handleKeyDownEventOtp(e: KeyboardEvent) {
      this.resetError();
      if (!((e.keyCode >= 48 && e.keyCode <= 57) ||
          e.keyCode === 39 || e.keyCode === 37 ||
          (e.keyCode >= 96 && e.keyCode <= 105) ||
          e.keyCode === 8 || e.keyCode === 46) && !(e.keyCode === 86 && e.ctrlKey)) {
        // only 0-9, backspace, delete button, left arrow, right arrow
        e.preventDefault();
      }
    },
    resetError() {
      this.prepareError = "";
      if (this.fetchResponse && this.fetchResponse.mfa_error_info && this.fetchResponse.mfa_error_info.message) {
        this.fetchResponse.mfa_error_info = {};
      }
    },
    handleKeyUpEventOtp() {
      if (TOTP_REGEX.test(this.fetchOtp)) {
        if (this.fetchOtp.length === 6) {
          this.fetch();
        }
      }
    },
    async handlePaste(e) {
      const text = await e.clipboardData.getData('text');
      if (isNaN(+text)) {
        e.preventDefault();
        return;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
